import { type ICommonAppData } from "lib/types/sanity";
import type Color from 'lib/types/Color';
import { getBoldWeight } from "lib/client/fonts";

export default function createCssVars(appData?: ICommonAppData) {
    const colorVars = [];
    try {
        if (appData?.settings) {
            const propNames = Object.getOwnPropertyNames(appData.settings);
            //console.debug(propNames)
            // output colors
            for (const propName of propNames) {

                if (propName.startsWith("color_")) {
                    const col = appData.settings[propName] as Color;
                    if (propName === "color_ticketbutton_bg" && !propNames.includes("color_ticketbutton_datebg_other")) {
                        if (col.hex === "#000000") {
                            // if the ticketbutton is set to black, and no "every other other date" color is set, we must set some sensible defaults
                            colorVars.push(`--color_ticketbutton_datebg_other: #fff; `);
                            colorVars.push(`--color_ticketbutton_datetext_other: #000; `);
                        } else if (col.hex === "#ffffff") {
                            colorVars.push(`--color_ticketbutton_datebg_other: #000; `);
                            colorVars.push(`--color_ticketbutton_datetext_other: #fff; `);
                        }
                    }
                    if (col?.rgb) {
                        colorVars.push(`--${propName}: rgb(${col.rgb.r}, ${col.rgb.g}, ${col.rgb.b});`);
                        // allow every color to have an 80% opacity value
                        colorVars.push(`--${propName}_rgb: ${col.rgb.r}, ${col.rgb.g}, ${col.rgb.b};`);
                    }

                }
            }

            if (!propNames.includes("color_ticketbutton_bg") && !propNames.includes("color_ticketbutton_datebg_other")) {
                // default bg color will be black, and no "every other other date" color is set, we must set some sensible defaults
                colorVars.push(`--color_ticketbutton_datebg_other: #fff; `);
                colorVars.push(`--color_ticketbutton_datetext_other: #000; `);
            }

            if (appData?.settings?.font_headers) {
                colorVars.push(`--font_bold: ${getBoldWeight(appData.settings.font_headers)};`);
                colorVars.push(`--font_family: "${appData.settings.font_headers}",Helvetica,Arial,sans-serif;`);
            } else {
                colorVars.push(`--font_bold: bold;`);
                colorVars.push(`--font_family: "Open Sans",Helvetica,Arial,sans-serif;`);
            }

        }
    } catch (err) {
        console.error(err);
    }
    return `:root{${colorVars.join("")}}`;
}